module.exports = __webpack_public_path__ + "img/partner6.c81eaa78.png";